
import { animate, inView, stagger, scroll } from "motion"

export const motion = async (err) => {
  if (err) {
    console.error(err);
  }

  if (document.getElementsByTagName('section').length) {
      inView('section:not([data-motion="false"])', (element) => {
        animate(element, 
            { opacity: [0, 1], y: [200, 0] },
            {
                duration: 0.5,
                easing: [0.17, 0.55, 0.55, 1],
            }
          );
    });
    
  }

  if (document.getElementsByClassName('motionjs-from-right').length) {
    inView('.motionjs-from-right', (element) => {
      animate(element, 
        { opacity: [0, 1], x: [400, 0] },
        {
            duration: 0.5,
            easing: [0.17, 0.55, 0.55, 1],
        }
      );
    });
  }

  if (document.getElementsByClassName('motionjs-from-left').length) {
    inView('.motionjs-from-left', (element) => {
      animate(element, 
        { opacity: [0, 1], x: [-400, 0] },
        {
            duration: 0.5,
            easing: [0.17, 0.55, 0.55, 1],
        }
      );
    });
  }

  if (document.getElementsByClassName('motionjs-from-bottom').length) {
    inView('.motionjs-from-bottom', (element) => {
      animate(element, 
        { opacity: [0, 1], y: [-400, 0] },
        {
            duration: 0.5,
            easing: [0.17, 0.55, 0.55, 1],
        }
      );
    });
  }

  if (document.getElementsByClassName('motionjs-from-top').length) {
    inView('.motionjs-from-top', (element) => {
      animate(element, 
        { opacity: [0, 1], y: [400, 0] },
        {
            duration: 0.5,
            easing: [0.17, 0.55, 0.55, 1],
        }
      );
    });
  }

  if (document.getElementsByClassName('motionjs-fade-in').length) {
    inView('.motionjs-fade-in', (element) => {
      animate(element, 
        { opacity: [0, 1] },
        {
            duration: 0.5,
            easing: [0.17, 0.55, 0.55, 1],
        }
      );
    });
  }

  // The statistics cards are one set of nodes shared by both layouts, so the
  // staggered slide-in is gated to the desktop layout it was designed for.
  if (
    document.getElementsByClassName('motion_stagger_bullet').length &&
    window.matchMedia('(min-width: 64rem)').matches
  ) {
    inView('.motion_stagger_bullet', (element) => {
      animate('.motion_stagger_bullet', 
        { opacity: [0, 1], x: [100, 0] },
        {
            duration: 0.5,
            easing: ['easyIn'],
            delay: stagger(0.4)
        },
      );
    });
  }


  var lastScrollTop = 0;
    window.onscroll = function() {
        var st = window.pageYOffset || document.documentElement.scrollTop;
        var currentScrollPos = window.pageYOffset;
      
        // 20 is an arbitrary number here, just to make you think if you need the prevScrollpos variable:
        if (st > lastScrollTop) {
          // I am using 'display' instead of 'top':
          document.getElementsByClassName("main-header")[0].classList.add("main-header--hide");
          if (document.getElementsByClassName('scroll-navigation').length) {
          document.getElementsByClassName("scroll-navigation")[0].classList.remove("scroll-navigation--down");
          }
        } else {
          document.getElementsByClassName("main-header")[0].classList.remove("main-header--hide");
          if (document.getElementsByClassName('scroll-navigation').length) {
          document.getElementsByClassName("scroll-navigation")[0].classList.add("scroll-navigation--down");
          }
        }

        if (currentScrollPos < 10) {
            // I am using 'display' instead of 'top':
            document.getElementsByClassName("main-header")[0].classList.add("main-header--attop");
          } else {
            document.getElementsByClassName("main-header")[0].classList.remove("main-header--attop");
          }

        lastScrollTop = st <= 0 ? 0 : st;
      }
  
};

import.meta.webpackHot?.accept(motion);
